// @flow

// Redux
import { connect } from 'react-redux'

// Selectors, Action Creators, Operator
import { isBooting$ } from 'hfty'
// Operator
type Props = {
  isBooting: boolean,
}

const mapStateToProps = function (state: Object): Props {
  return {
    isBooting: isBooting$(state),
  }
}

export default connect(mapStateToProps)
